import { formatAddress as addressFormatter } from "localized-address-format";

import type { Address } from "~/types";

/**
 * Format an address for display
 * Extracted to separate module to enable code splitting of heavy localized-address-format dependency
 */
export const formatAddress = ({
  line1 = "",
  line2 = "",
  city = "",
  state = null,
  postalCode = "",
}: Address = {}): string[] => {
  if (!line1 && !line2 && !city && !state && !postalCode) {
    return [];
  }

  const address = {
    locality: city,
    administrativeArea: state,
    postalCode: postalCode,
    postalCountry: "US",
    addressLines: line1 || line2 ? [line1, line2].filter(Boolean) : undefined,
  };

  const addressRemovedUndefined = Object.keys(address).reduce((acc, key) => {
    if (address[key]) {
      acc[key] = address[key];
    }
    return acc;
  }, {});

  return addressFormatter(addressRemovedUndefined);
};

/**
 * Convert address array to single string
 */
export const formatAddressToString = (props: Address): string => {
  const addressLines = formatAddress(props);
  return addressLines.join(", ");
};
